import { render } from "./AccountPlanPicker.vue?vue&type=template&id=0bb0ffc4"
import script from "./AccountPlanPicker.vue?vue&type=script&lang=js"
export * from "./AccountPlanPicker.vue?vue&type=script&lang=js"
script.render = render

export default script